import { ICardMotorsportsTeamsRanking, CardMotorsportsTeamsRanking } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { DataCardTeamRankingQuery } from "./types";

import transformQuery from "./transformers/query-transformer";
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<DataCardTeamRankingQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<DataCardTeamRankingQuery>): ICardMotorsportsTeamsRanking => {
  return transformQuery(props);
}

const ResultsContainer = ({
  props,
  ...rest
}: WidgetContext<ICardMotorsportsTeamsRanking>) => {
  log({ props, ...rest });
  const intCmpEventHandler = useIntcmp();

  return (
    <div onClick={intCmpEventHandler}>
        <CardMotorsportsTeamsRanking {...props} />
    </div>
  );
}

export default ResultsContainer;